// Partner brand colors, deliberately kept out of THEME.colors: those tokens exist so Levitate's own
// palette can change in one place, and a vendor rebrand is not a theme change. Shared here because
// the 8am mark covers more than one card.
export const eightAmColor = '#E6411B';

export const eightAmColorTranslucent = `${eightAmColor}1b`;

// Shared here because the DonorPerfect mark covers both the V1 and V2 cards.
export const donorPerfectColor = '#00B8F9';
